<ngx-ui-loader></ngx-ui-loader>
<div class="app-wrapper app-content" [class.blocked]="!isOnline()">
  <router-outlet></router-outlet>
</div>
@if (!isOnline()) {
  <div class="offline-overlay">
    <div class="offline-box">
      <h2>No Internet Connection</h2>
      <p>Please check your connection.</p>
    </div>
  </div>
}
<div class="app-blocker">
  <div>
    <h2>Desktop Only</h2>
    <p>Please open this application on a larger screen.</p>
  </div>
</div>
